import React, { useEffect, useRef } from 'react'

import ImageGallery from 'react-image-gallery'

import styles from './styles'


const DEFAULT_PROPS = {
  slideDuration: 0
}

const Gallery = props => {
  const ref = useRef(null)

  useEffect(() => {
    const images = ref.current.getElementsByTagName('img')

    Array.from(images, (el) => {
      el.setAttribute("height", "400")
      el.setAttribute("width", "730")
    })
  }, [ref.current])

  const propsWithDefaults = {...DEFAULT_PROPS, ...props}

  return (
    <div
      ref={ref}
      id="imageGallery"
      className="image-gallery-wrapper"
      style={{ width: '100%', height: '100%' }}
    >
      <ImageGallery {...propsWithDefaults} ref={props.ref || props.setGalleryRef} />
      <style jsx global>
        {styles}
      </style>
    </div>
  )
}

export default Gallery
